import React from 'react'
import { FaFacebookF } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa6";
import { FaGithub } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import Hero from '../Assets/hero.jpg'

const Home = () => {
  return (
    <>
    <div className='home'>
   
        <div className="about">
        <img className="hero" src={Hero} alt="pretty boy" />
          <h1> Hello, my name is John Dale</h1>
           <p> Aspiring full stack developer based in Cebu Philippines </p>
           <div className='icons'>
             <a href="https://github.com/dingdingwall"> < FaGithub/></a>
             <a  href="https://www.youtube.com/channel/UC1nHufu_wGVaj4wgePXA3ZA"> <FaYoutube/></a>
             <a  href="https://www.facebook.com/johndale.pardillo"> <FaFacebookF/></a>
             <a href="https://www.instagram.com/dingdingwall/"> <FaInstagram/></a>
             </div>
             <button className='btn-cv'>View Resume</button>
             <div className="Skills">
              <h1>Skills</h1>
              <h2>Front-End</h2>
              <h3>React Js, Html, Css, Tailwind, Bootstrap, Javascript, MaterialUI, NPM.</h3>
              <h2>Back-End</h2>
              <h3>Node Js, MySQL, SQL.</h3>
              <h2>Languages</h2>
              <h3>C#, JAVA, Javascript, Python, C. </h3>
             </div>
  
             <div className="Skills">
              <h1 className='me'>About Me</h1>
            
            
              <p>I am  an aspiring full stack developer who has a passion for technology and coding. <br/>
               I spend most of my time coding and learning new programming languages that interests me. </p>
             
              </div>
             
             
        </div>


    
        
      
     </div>

     
       
      </>
  )
}

export default Home